import React, { useEffect, useState } from 'react';
import useApp from 'hooks/useApp'
import { Button } from 'components'

const AppError2 = () => {

	const App = useApp()
	const [errorOpen, setErrorOpen] = useState(false)

	const openError = () => {
		setErrorOpen(!errorOpen)
	}

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: "",
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="flex_1 padding center-cont">
				<i className="icon icon_error_tri" />
				<h3 className="intro-tit mt_20">에러가 발생했어요.</h3>
				<span className="intro-sub-tit mt_10">다시 시도하거나 지속적인 에러 발생 시<br />
					모니에 문의해주세요.
				</span>
				<div className={`error-box ${errorOpen ? "active" : ""} mt_20`} onClick={openError}>
					<div className="title">
						<p>error_code_404</p>
						<i className="icon icon_arrow_sm bottom" />
					</div>
					<div className="contents">
						<hr className="my_20" />
						<div>
							통신사 ‘명의도용알림 서비스’로 인증번호 수신이 어려울 수 있습니다. 통신사에 직접 문의하여 해지해주세요.
						</div>
					</div>
				</div>
			</div>
			<div className="flex-shrink_0 padding">
				<Button className="btn btn--big">재시도</Button>
			</div>
		</div>
	)
}

export default AppError2